/*
  Usando el IntersectionObserver
  Los observadores son objetos que detectan algo en tiempo real.
  Y hay diferentes observadores, que detectan diferentes cosas,
  como MutationObserver, donde puede buscar cambios en el DOM,
  por ejemplo. Y necesitamos en este caso el IntersectionObserver.
*/
const animatedScrollObserver = new IntersectionObserver(
    (entries, animatedScrollObserver) => {
      /*
        Recorrer todas las entradas que se observan.
      */
      entries.forEach((entry) => {
        /*
          Con esta condición, verificamos si el elemento está en la ventana gráfica actual,
          respectivamente, si la entrada se cruza con la ventana gráfica.
          Si es verdadero, agregamos la clase enter y llamamos a la función unobserve.
          Porque ya no tenemos que observarlo.
        */
        if(entry.isIntersecting) {
          entry.target.classList.add('enter');
          animatedScrollObserver.unobserve(entry.target);
        }
      });
    }
);
  
  /*
    El objeto de nuestra directiva vue.
    Vue.js proporciona varias funciones de enlace que puede usar para una directiva.
    Solo necesitamos uno de ellos, la función de enlace,
    que se llama solo una vez cuando la directiva está vinculada al elemento.
    Aquí es donde puede realizar algunos trabajos de configuración, por ejemplo.
    En este caso, agregamos una nueva clase CSS al elemento y lo observamos.
  */
  export default {
    bind(el) {
      el.classList.add('before-enter');
      animatedScrollObserver.observe(el);
    }
  }